import { createFileRoute } from '@tanstack/react-router';

import { ThreadsView } from '../../../features/messenger/ui/threads-view.tsx';

export const Route = createFileRoute('/_app/messages/threads')({
  component: ThreadsView,
});
